import { Typography } from 'antd';

import ImageRatio from '@/components/shared/ImageRatio';
import Shelf from '@/components/shared/Shelf';
import { getCdnUrl } from '@/helpers';
import { ICourseShelf } from '@/interfaces/course';
import { useGetCourseShelfQuery } from '@/services/resume';
import { DOMAIN, MAIN_SUBDOMAIN } from '@/settings';
import styled, { StyledProp, css } from '@/styled';

import CourseDefaultCover from './DefaultCover';

interface IProps extends StyledProp {}

const ModulesShelf = (props: IProps) => {
  const { data, isFetching } = useGetCourseShelfQuery('');

  if (!data?.length && !isFetching) {
    return null;
  }

  return (
    <>
      {data?.map(course => (
        <div key={course.id} {...props}>
          <Shelf
            shelfProps={{
              isFetching,
              skeletonAspectRatio: '9:16',
              withBorder: true
            }}
            title={
              <>
                <Typography.Title level={3} ellipsis>
                  {course.title}
                </Typography.Title>
                <Typography.Link
                  underline
                  href={getCourseDomain(course)}
                  target={getCourseDomainTarget(course)}
                  rel='noopener noreferrer'
                  id={`seeCourse-clickable-text-${course.id}`}
                >
                  Ver curso
                </Typography.Link>
              </>
            }
            carouselProps={{ slidesToShow: 5 }}
          >
            {course.modules.map(module => {
              if (!module.banner) {
                return (
                  <swiper-slide key={module.id}>
                    <CourseDefaultCover to={getCourseDomain(course)} {...module} />
                  </swiper-slide>
                );
              }

              return (
                <swiper-slide key={module.id}>
                  <div className='hover' id={`card-module-${module.id}`}>
                    <CourseDefaultCover
                      className='cover'
                      to={getCourseDomain(course)}
                      target={getCourseDomainTarget(course)}
                      {...module}
                    />
                    <ImageRatio aspect='9:16' src={getCdnUrl(module.banner)} alt={module.title} />
                  </div>
                </swiper-slide>
              );
            })}
          </Shelf>
        </div>
      ))}
    </>
  );
};

export default styled(ModulesShelf)(
  ({ theme }) => css`
    & .carouselNavigator-container {
      height: 100%;
    }

    .hover {
      .cover {
        transition: ${theme.motionDurationSlow};
        position: absolute;
        background-color: ${theme.palette.alpha(theme.palette.gray[12], 0.8)};
        opacity: 0;
        z-index: 3;

        ${theme.breakpoints.down('md')} {
          opacity: 1;
        }

        svg {
          color: white;
        }
      }

      &:hover {
        .cover {
          opacity: 1;
        }
      }
    }
  `
);

function getCourseDomain(course: ICourseShelf) {
  return `https://${course?.portal?.subdomain || MAIN_SUBDOMAIN}${DOMAIN}/curso/${course.hash}`;
}

function getCourseDomainTarget(course: ICourseShelf) {
  return course?.portal?.subdomain ? '_blank' : '_self';
}
